import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_ENGINE = defineFcm('starter_experience_dashboard_engine')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ countryValue, localeValue }) => countryValue && localeValue)
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-middle-end',
		context: 'Starter Dashboard',
		description: `Turns on the dynamic starter dashboard engine: when on, the starter dashboard shows the engine's items instead of today's banners. Off by default; turning it off is the kill switch, and everyone goes back to today's banners. Staff follow this flag like everyone else.

			To turn it on for a market, add a row for its country and one for its locale (for example US and en-US).

			Leave this off in production until the starterDashboard items are live: until then the engine has no items to show.`,
		mergeLogic:
			'Checks both country and locale; both must be enabled for the engine to be on. A country or locale without a row is off.',
		supportedGroups: { countries: true, locales: true },
	});
